import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

@Injectable({
  providedIn: 'root'
})
export class ApiService {

  constructor(private http: HttpClient) { }

  getStats(): Observable<any> {
    return this.http.get(environment.api + '/observables/stats');
  }

  search(data): Observable<any> {
    return this.http.post(environment.api + '/observables/search/by-value', {
      data
    }).pipe(
      map(obj => {
        obj['analysis_summary'] = {};
        for (let a of obj['analysis']) {
          if (a.score !== undefined) {
            if (a.score > 0.5)
              a.level = 'MALICIOUS';
            else if (a.score > 0.25)
              a.level = 'SUSPICIOUS';
            else
              a.level = 'SAFE';
          }
          if (obj['analysis_summary'][a.id])
            obj['analysis_summary'][a.id].push(a);
          else
            obj['analysis_summary'][a.id] = [a];
        }
        obj['sources_summary'] = {};
        for (let s of obj['sources']) {
          if (obj['sources_summary'][s.type])
            obj['sources_summary'][s.type]++;
          else
            obj['sources_summary'][s.type] = 1;
        }
        return obj;
      })
    );
  }

  context(data): Observable<any> {
    return this.http.get(environment.api + '/observables/context', {
      params: {
        data
      },
      headers: {
        'API-Key': 'my_api_key'
      }
    });
  }
}
